import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const BANK_OF_AMERICA_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.bankOfAmerica.buyBox.bulletPoint1' },
        { title: 'productPage.bankOfAmerica.buyBox.bulletPoint2' },
        { title: 'productPage.bankOfAmerica.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.bankOfAmerica.buyBox.productName',
      textLink: 'productPage.bankOfAmerica.buyBox.textLink',
      interactService: {
        service: 'bank_of_america_offer'
      },
      interactTextLink: {
        url: 'https://promotions.bankofamerica.com/smallbusiness/alliance/terms',
        target: 'external'
      }
    }],
    headerPicture: {
      src: '/s2/raster/woman-smiling-bank-of-america-desktop.png',
      alt: 'productPage.bankOfAmerica.heroPicture.altText'
    },
    headline: 'productPage.bankOfAmerica.page.headline',
    partnerLogo: {}, // intentionally empty — suppresses partner logo display
    partnerReviewBlanks: [], // intentionally empty — suppresses review section
    subheader: 'productPage.bankOfAmerica.page.subheader'
  },
  benefit: {
    title: 'productPage.bankOfAmerica.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.bankOfAmerica.valueProp.propTitle1',
        description: 'productPage.bankOfAmerica.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/requestquoterounded.svg',
        title: 'productPage.bankOfAmerica.valueProp.propTitle2',
        description: 'productPage.bankOfAmerica.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/creditscorerounded.svg',
        title: 'productPage.bankOfAmerica.valueProp.propTitle3',
        description: 'productPage.bankOfAmerica.valueProp.shortCopy3'
      },
      {
        icon: '/s2/material-icons/calculaterounded.svg',
        title: 'productPage.bankOfAmerica.valueProp.propTitle4',
        description: 'productPage.bankOfAmerica.valueProp.shortCopy4'
      }
    ]
  },
  howItWorks: {
    title: 'productPage.bankOfAmerica.howItWorks.title',
    items: [
      {
        title: 'productPage.bankOfAmerica.howItWorks.step1'
      },
      {
        title: 'productPage.bankOfAmerica.howItWorks.step2'
      },
      {
        title: 'productPage.bankOfAmerica.howItWorks.step3'
      },
      {
        title: 'productPage.bankOfAmerica.howItWorks.step4'
      }
    ],
    image: '/s2/raster/bank-america-how-it-works.png',
    alt: 'productPage.bankOfAmerica.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  assistance: {
    title: 'productPage.bankOfAmerica.needAssistance.title',
    getInTouch: 'productPage.bankOfAmerica.needAssistance.getInTouch',
    actions: 'productPage.bankOfAmerica.needAssistance.actions'
  },
  getBuyButtonConfig: (entitlements, service) => getBuyButtonConfig({
    entitlements,
    service,
    ctaText: 'productPage.bankOfAmerica.buyBox.buttonLabel'
  })
};
